import React, { useEffect, useState } from "react";
import "../../css/Dashboard.css";
import { ref, push, getDatabase, onValue } from "firebase/database";
import { useNavigate } from "react-router-dom";
import { useAdminAuth } from "../../component/AdminUserPresent";

const Dashboard = () => {
	const [productCount, setProductCount] = useState(0);
	const [userCount, setUserCount] = useState(0);
	const [queryCount, setQueryCount] = useState(0);
	const isAdmin = useAdminAuth();
	const navigate = useNavigate();

	const getDahboardDetails = (cat) => {
		const db = getDatabase();
		const userRefUsers = ref(db, `${cat}/`);
		const unsubscribe = onValue(userRefUsers, (snapshot) => {
			if (snapshot.exists()) {
				const data = snapshot.val();
				if (cat === "productDetails") {
					const products = Object.values(data) // categories
						.flatMap((category) => Object.values(category)); // products
					setProductCount(products.length);
				} else if (cat === "users" || cat === "customerquery") {
					const productData = data && Object.values(data);
					cat === "users" && setUserCount(productData.length);
					cat === "customerquery" &&
						setQueryCount(productData.length);
				}
			}
		});
		return () => unsubscribe();
	};

	useEffect(() => {
		if (!isAdmin) return;
		getDahboardDetails("productDetails");
		getDahboardDetails("users");
		getDahboardDetails("customerquery");
	}, []);

	return (
		<div className="container">
			<div className="text-center">
				<h2>Dashboard</h2>
			</div>
			<div className="row">
				<div className="dashboard-card">
					<div className="pt-4">Total Products</div>
					<div className="py-4">{productCount}</div>
					<div className="dashboard-card-btn">
						<button
							onClick={() => {
								navigate("/productlisted");
								window.scrollTo(0, 0);
							}}
						>
							Product list
						</button>
					</div>
				</div>
				<div className="dashboard-card">
					<div className="pt-4">Total Customer</div>
					<div className="py-4">{userCount}</div>
					<div className="dashboard-card-btn">
						<button
							onClick={() => {
								navigate("/customerdetails");
								window.scrollTo(0, 0);
							}}
						>
							Customer details
						</button>
					</div>
				</div>
				<div className="dashboard-card">
					<div className="pt-4">Customer Query</div>
					<div className="py-4">{queryCount}</div>
					<div className="dashboard-card-btn">
						<button
							onClick={() => {
								navigate("/customerquery");
								window.scrollTo(0, 0);
							}}
						>
							Customer query
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Dashboard;
